import { Component, Input, OnInit } from "@angular/core";
import { BrandingService } from "src/app/core/services/branding.service";
import { AssistantContent } from "../../../models";

@Component({
  selector: "app-assistant-popup-content",
  templateUrl: "./assistant-popup-content.component.html",
  styleUrls: ["./assistant-popup-content.component.scss"],
  standalone: false,
})
export class AssistantPopupContentComponent implements OnInit {
  @Input() content: AssistantContent;

  constructor(public brandingService: BrandingService) {}

  ngOnInit(): void {}
}
